import { Balance } from "@mui/icons-material";
import { TableCell, TableRow, Typography, IconButton } from "@mui/material";

import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";
import { getBackgroundColor } from "../../helper/functions";
import CustomMapPinTooltip from "../Tooltip/CustomMapPinTooltip";

export default function ProviderTableRow({
  row,
  assignedProvider,
  onClickDetail,
  onSelect,
  onDeselect,
  address,
  initAddress,
}) {
  const handleClick = () => onSelect(row);

  return (
    <TableRow
      key={row.id}
      onClick={handleClick}
      sx={{
        cursor: "pointer",
        "&:hover": { backgroundColor: HNSColors.tertiary[900] },
        "&:last-child td, &:last-child th": { border: 0 },
        width: "40%",
      }}
    >
      <TableCell sx={{ whiteSpace: "normal", wordBreak: "break-word", width: "40%" }}>
        <div className="flex items-center gap-2">
          <CustomMapPinTooltip data={row} color={getBackgroundColor(row)}>
            <Svg
              name={SvgEnum.HisMapPin}
              color={getBackgroundColor(row)}
              sx={{ width: 24, height: 24 }}
            />
          </CustomMapPinTooltip>
          <Typography sx={{ color: HNSColors.neutrals[100] }}>{row.name}</Typography>
          {row.favorite && (
            <Balance
              titleAccess="Law firm favorite"
              sx={{ color: HNSColors.primary[500], width: 20, height: 20 }}
            />
          )}
        </div>
      </TableCell>

      <TableCell align="left" sx={{ width: "30%" }}>
        {Array.isArray(row?.providerTypes) ? row.providerTypes.map((pt) => pt.name).join(", ") : ""}
      </TableCell>

      <TableCell align="left" sx={{ width: "5%" }}>
        {row?.rating ?? "-"}
      </TableCell>

      <TableCell align="left" sx={{ width: "20%" }}>
        {row?.distance} miles
        {(address ?? initAddress)?.label && (
          <>
            <span style={{ color: HNSColors.neutrals[200] }}> from </span>
            <span className="font-bold" style={{ color: HNSColors.primary[500] }}>
              {(address ?? initAddress)?.label}
            </span>
          </>
        )}
      </TableCell>

      <TableCell align="left" sx={{ width: "60px" }}>
        <div className="flex gap-1">
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onClickDetail(row);
            }}
          >
            <Svg
              name={SvgEnum.HisSearch2}
              color={HNSColors.primary[500]}
              sx={{ width: 24, height: 24 }}
            />
          </IconButton>

          {assignedProvider && (
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onDeselect();
              }}
            >
              <Svg
                name={SvgEnum.HisX}
                color={HNSColors.failure[500]}
                sx={{ width: 24, height: 24 }}
              />
            </IconButton>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
}
